module.exports = __webpack_public_path__ + "img/WKS_3.43b6e4a0.jpg";